import { LoadingSpinner } from './LoadingSpinner'

export function PageLoadingFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <LoadingSpinner size="lg" text="Loading page..." />
    </div>
  )
}
